module.exports = __webpack_public_path__ + "img/fabric-slide-2-xxl.78ed271.webp";